import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { AbstractRtpSettlementService } from '../abstraction/abstract.rtp-settlement.service';
import { IRtpSettlementTransaction } from '../../interfaces/settlement/rtp-settlement-transaction.interface';

@Injectable({
  providedIn: 'root',
})
export class MockRtpSettlementService extends AbstractRtpSettlementService {
  private getTransactionsByRespondentAndCycleJson =
    'assets/mocks/rtp/settlement/getTransactionsByRespondentAndCycle.json';

  override getTransactionsByRespondentAndCycle(
    respondentRtn: string,
    cycleDate: string,
    reconWindowId: number
  ): Promise<IRtpSettlementTransaction[] | undefined> {
    return lastValueFrom(
      this.http
        .get<IRtpSettlementTransaction[]>(this.getTransactionsByRespondentAndCycleJson)
        .pipe(
          map(transactions =>
            transactions.filter(transaction => transaction.RespondentRtn === respondentRtn)
          )
        )
    );
  }
  constructor(private http: HttpClient) {
    super();
  }
}
